import $ from 'jquery';
import trackMetrics from 'trackMetrics';
import stylesTable from 'styles/table';

export function isValidCountry(country) {
	return !!stylesTable[`iconCountry${country}`];
}

export function getCookie(name) {
	const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
	return value ? value.pop() : '';
}

export function mapCountryCode(countryCode) {
	return __DEV__ ? 'GBR' : {
		AF: 'AFG', AL: 'ALB', DZ: 'ALG', AS: 'ASA', AD: 'AND', AO: 'ANG', AG: 'ANT', AR: 'ARG', AM: 'ARM', AW: 'ARU', AU: 'AUS', AT: 'AUT', AZ: 'AZE',
		BS: 'BAH', BH: 'BRN', BD: 'BAN', BB: 'BAR', BY: 'BLR', BE: 'BEL', BZ: 'BIZ', BJ: 'BEN', BM: 'BER', BT: 'BHU', BO: 'BOL', BA: 'BIH', BW: 'BOT',
		BR: 'BRA', BN: 'BRU', BG: 'BUL', BF: 'BUR', BI: 'BDI', KH: 'CAM', CM: 'CMR', CA: 'CAN', CV: 'CPV', KY: 'CAY', CF: 'CAF', TD: 'CHA', CL: 'CHI',
		CN: 'CHN', CO: 'COL', KM: 'COM', CG: 'CGO', CK: 'COK', CR: 'CRC', HR: 'CRO', CU: 'CUB', CY: 'CYP', CZ: 'CZE', CI: 'CIV', DK: 'DEN', DJ: 'DJI',
		DM: 'DMA', DO: 'DOM', KP: 'PRK', CD: 'COD', EC: 'ECU', EG: 'EGY', SV: 'ESA', GQ: 'GEQ', ER: 'ERI', EE: 'EST', ET: 'ETH', FJ: 'FIJ', FI: 'FIN',
		FR: 'FRA', GA: 'GAB', GM: 'GAM', GE: 'GEO', DE: 'GER', GH: 'GHA', GB: 'GBR', GR: 'GRE', GD: 'GRN', GU: 'GUM', GT: 'GUA', GN: 'GUI', GW: 'GBS',
		GY: 'GUY', HT: 'HAI', HN: 'HON', HK: 'HKG', HU: 'HUN', IS: 'ISL', IN: 'IND', ID: 'INA', IR: 'IRI', IQ: 'IRQ', IE: 'IRL', IL: 'ISR', IT: 'ITA',
		JM: 'JAM', JP: 'JPN', JO: 'JOR', KZ: 'KAZ', KE: 'KEN', KI: 'KIR', KW: 'KUW', KG: 'KGZ', LA: 'LAO', LV: 'LAT', LB: 'LBN', LS: 'LES', LR: 'LBR',
		LY: 'LBA', LI: 'LIE', LT: 'LTU', LU: 'LUX', MG: 'MAD', MW: 'MAW', MY: 'MAS', MV: 'MDV', ML: 'MLI', MT: 'MLT', MH: 'MHL', MR: 'MTN', MU: 'MRI',
		MX: 'MEX', FM: 'FSM', MK: 'MKD', MC: 'MON', MN: 'MGL', ME: 'MNE', MA: 'MAR', MZ: 'MOZ', MM: 'MYA', NA: 'NAM', NR: 'NRU', NP: 'NEP', NL: 'NED',
		NZ: 'NZL', NI: 'NCA', NE: 'NIG', NG: 'NGR', NO: 'NOR', OM: 'OMA', PK: 'PAK', PW: 'PLW', PS: 'PLE', PA: 'PAN', PG: 'PNG', PY: 'PAR', PE: 'PER',
		PH: 'PHI', PL: 'POL', PT: 'POR', PR: 'PUR', QA: 'QAT', KR: 'KOR', MD: 'MDA', RO: 'ROU', RU: 'RUS', RW: 'RWA', KN: 'SKN', LC: 'LCA', WS: 'SAM',
		SM: 'SMR', ST: 'STP', SA: 'KSA', SN: 'SEN', RS: 'SRB', SC: 'SEY', SL: 'SLE', SG: 'SGP', SK: 'SVK', SI: 'SLO', SB: 'SOL', SO: 'SOM', ZA: 'RSA',
		SS: 'SSD', ES: 'ESP', LK: 'SRI', VC: 'VIN', SD: 'SUD', SR: 'SUR', SZ: 'SWZ', SE: 'SWE', CH: 'SUI', SY: 'SYR', TJ: 'TJK', TZ: 'TAN', TH: 'THA',
		TL: 'TLS', TG: 'TOG', TO: 'TGA', TT: 'TTO', TN: 'TUN', TR: 'TUR', TM: 'TKM', TV: 'TUV', UG: 'UGA', UA: 'UKR', AE: 'UAE', US: 'USA', UY: 'URU',
		UZ: 'UZB', VU: 'VAN', VE: 'VEN', VN: 'VIE', VG: 'IVB', VI: 'ISV', YE: 'YEM', ZM: 'ZAM', ZW: 'ZIM'
	}[countryCode];
}

export function startTracking(domEl, compactDisplayName) {
	const $trackingTarget = $(domEl);
	const namespace = 'pyeongchang olympics';
	const name = {nextEvent: 'schedule', latestResult: 'results', topMedals: 'medals'}[compactDisplayName] || 'widget';
	const view = compactDisplayName ? 'compact' : 'highlights';
	const container = $(document.body).hasClass('pg-article') ? 'article' : 'section';
	const CNN = window.CNN = window.CNN || {omniture: {}};

	CNN.omniture.IsOlympicWidget = true;

	// There is already another widget(s) on the page
	if (CNN.omniture.TypeOlympicWidget) {
		const typeParts = CNN.omniture.TypeOlympicWidget.split(':');
		const nameParts = typeParts[1].split('_');
		const viewParts = typeParts[2].split('_');

		nameParts.push(name);
		viewParts.push(view);

		CNN.omniture.TypeOlympicWidget = `${namespace}:${nameParts.join('_')}:${viewParts.join('_')}:${container}`;
	} else {
		CNN.omniture.TypeOlympicWidget = `${namespace}:${name}:${view}:${container}`;
	}

	$trackingTarget.on('click', '[data-tracking]', (event) => {
		const data = $(event.currentTarget).data('tracking');

		try {
			trackMetrics({
				type: 'user-interaction',
				data: {
					interaction: `${namespace}:${name}:${data}:click`
				}
			});
		} catch (e) {
			// JSMD library is missing
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/utils.es6